import { useContext } from "react";
import { LayoutContext } from ".";

export const useLayout = () => {
  const context = useContext(LayoutContext);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- dev protection
  if (!context && process.env.NODE_ENV !== "production")
    throw new Error("useLayout must be used within a Layout component");

  return context;
};
